export const pageMap = {
  1: "", // 首页
  2: "prodetail", // 产品详情页
  3: "cookbook/cookdetail", // 菜谱详情页
  4: "newsdetail", // 新闻详情页
};
